/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { Left, NonEmptyList, Right } from 'purify-ts';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function isEmpty(val) {
    return (val ?? '').match(/\S/) == null;
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function errOrData(errs, data) {
    return NonEmptyList.fromArray(errs).toEither(data).swap();
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function mergeEithers(a, b) {
    return a.caseOf({
        Left: errA => b.caseOf({
            Left: errB => Left(errA.concat(errB)),
            Right: () => Left(errA),
        }),
        Right: dataA => b.caseOf({
            Left: errB => Left(errB),
            Right: dataB => Right({ ...dataA, ...dataB }),
        }),
    });
}
